<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M16.25 17.8571V16.0714C16.25 15.1242 15.8737 14.2158 15.204 13.546C14.5342 12.8763 13.6258 12.5 12.6786 12.5H7.32143C6.37423 12.5 5.46582 12.8763 4.79605 13.546C4.12627 14.2158 3.75 15.1242 3.75 16.0714V17.8571"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.0011 9.01786C11.9736 9.01786 13.5725 7.41888 13.5725 5.44643C13.5725 3.47398 11.9736 1.875 10.0011 1.875C8.02867 1.875 6.42969 3.47398 6.42969 5.44643C6.42969 7.41888 8.02867 9.01786 10.0011 9.01786Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconUser',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
